import {Component, Input, OnInit, signal, WritableSignal} from '@angular/core';
import { LMBuilderModel } from "@components/builder/services/lm-builder-model.service";
import { LMReportPersonalizationDialogService } from "@app/components";

@Component({
  selector:    'lm-builder-display-field-sorting',
  standalone: false,
  templateUrl: './lm-builder-display-field-sorting.component.html',
  styleUrl: './lm-builder-display-field-sorting.component.scss',
})
export class LMBuilderDisplayFieldSortingComponent implements OnInit {
  @Input() spec!: LMListPSpec;
  @Input() displayField!: LMDisplayFieldPSpec | undefined;
  @Input() fieldSpec: LMFieldPSpec | undefined;

  defaultSort = false;
  defaultSortDescending = false;
  sortSetName = '';
  sortSetLabel = '';
  sortSetDescription = '';
  setSpec: LMSetSpec | undefined;

  constructor(
    private lmBuilderModel: LMBuilderModel,
    private lmReportPersonalizationDialogService: LMReportPersonalizationDialogService
  ) {
      //no-op
  }

  ngOnInit(): void {
    this.initialize();
  }

  private initialize() {

    if (this.fieldSpec && this.fieldSpec.sort) {
      this.defaultSort = this.fieldSpec.sort.default;
      this.defaultSortDescending = this.fieldSpec.sort.descending;
      this.sortSetName = this.fieldSpec.sort.name;
      this.sortSetLabel = this.sortSetName;
      this.updateSortFromFacade();
    }
  }

  private updateSortFromFacade() {
    if (this.spec.metaDataOptions.setSpecs.hasOwnProperty(this.sortSetName)) {
      this.setSpec = this.spec.metaDataOptions.setSpecs[this.sortSetName];
      this.sortSetLabel = this.setSpec.label;
      this.sortSetDescription = this.setSpec.description;
    }
  }

  removeSort() {
    if (this.fieldSpec) {
      this.lmBuilderModel.removeDisplayFieldSort(this.fieldSpec);
      this.initialize();
    }
  }

  addSort = () => {
    this.editSort();
  };

  editSort() {
    this.lmReportPersonalizationDialogService.openAddSortDialog({ usingFacade: true, columnField: this.fieldSpec?.fieldId, setSpecs: this.spec.metaDataOptions.setSpecs }).subscribe(response => {
      if (response?.status === 'OK') {
        this.defaultSort = response.default;
        this.defaultSortDescending = response.default ? response.descending : false;
        this.sortSetName = response.sortOrder;
        this.sortSetLabel = this.sortSetName;
        this.sortSetDescription = '';

        this.updateSortFromFacade();
        this.updateDisplayFieldSort();
      }
    });
  }

  updateDisplayFieldSort() {
    if (this.fieldSpec) {
      if (!this.defaultSort) {
        this.defaultSortDescending = false;
      }
      this.lmBuilderModel.updateDisplayFieldSort(this.fieldSpec, this.sortSetName, this.defaultSort, this.defaultSortDescending);
    }
  }
}
